import { render } from "./WorldDetail.vue?vue&type=template&id=1f2be7e1"
import script from "./WorldDetail.vue?vue&type=script&lang=js"
export * from "./WorldDetail.vue?vue&type=script&lang=js"

import "./WorldDetail.vue?vue&type=style&index=0&id=1f2be7e1&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__